module.exports = __webpack_public_path__ + "img/check.cbcdbb30.svg";